import { atom } from 'recoil';

const findDefault = (list) => list.find((v) => v.default);

// ***************
// *** OPTIONS ***

export const VISITOR_AND_SPEND_DAYS = [
    {
        default: true,
        value: 'Wed',
        label: 'Wed',
    },
    {
        value: 'Sat',
        label: 'Sat',
    },
];

export const VISITOR_AND_SPEND_TIME_SLOTS_DAY = [
    '06-09',
    '09-12',
    '12-15',
    '15-18',
];

export const VISITOR_AND_SPEND_TIME_SLOTS_NIGHT = [
    '18-21',
    '21-24',
    '00-03',
    '03-06',
];

export const VISITOR_AND_SPEND_TIME_SLOTS = [
    {
        default: true,
        value: '09-12',
        label: '9am - 12pm',
        dayOrNight: 'day',
    },
    {
        value: '12-15',
        label: '12pm - 3pm',
        dayOrNight: 'day',
    },
    {
        value: '18-21',
        label: '6pm - 9pm',
        dayOrNight: 'night',
    },
];

const defaultOptions = {
    day: findDefault(VISITOR_AND_SPEND_DAYS).value,
    time_slot: findDefault(VISITOR_AND_SPEND_TIME_SLOTS).value,
};

export const visitorAndSpendOptionsAtom = atom({
    key: 'visitor-and-spend-options-atom',
    default: structuredClone(defaultOptions),
});

// ************
// *** TYPE ***

const newDataScaleItem = (value, fillColor) => {
    return { value, fillColor };
};

export const VISITOR_AND_SPEND_TYPES = [
    {
        default: true,
        id: 'visitor',
        label: 'Visitor Counts',
        gridShape: 'hex',
        gridIdField: 'hex_id',
        gridService: `https://gis.london.gov.uk/arcgis/rest/services/apps/Busyness_context/MapServer/11`,
        popupDescription:
            "BT's Footfall insights on the number of non-residents and non-workers spending at least 10 minutes within the hex at the selected time band.",
        dataProp: 'visitor',
        emptyCellProps: {
            visitor: 0,
            worker: 0,
            resident: 0,
        },
        dataScale: {
            day: [
                newDataScaleItem(0, '#ffffff'),
                newDataScaleItem(250, '#e2eef8'),
                newDataScaleItem(500, '#b2c9e9'),
                newDataScaleItem(1000, '#84a6d4'),
                newDataScaleItem(3000, '#5884b9'),
                newDataScaleItem(5000, '#326396'),
                newDataScaleItem(7500, '#18446c'),
                /*
        newDataScaleItem('< 250', null),
        newDataScaleItem(500, "#e2eef8"),
        newDataScaleItem(1000, "#b2c9e9"),
        newDataScaleItem(2000, "#84a6d4"),
        newDataScaleItem(3000, "#5884b9"),
        newDataScaleItem(5000, "#326396"),
        newDataScaleItem(7500, "#18446c"),
        */
            ],
            night: [
                newDataScaleItem(0, '#ffffff'),
                newDataScaleItem(250, '#e2eef8'),
                newDataScaleItem(500, '#b2c9e9'),
                newDataScaleItem(1000, '#84a6d4'),
                newDataScaleItem(3000, '#5884b9'),
                newDataScaleItem(5000, '#326396'),
                newDataScaleItem(7500, '#18446c'),
            ],
        },
        dataService: `https://gis.london.gov.uk/arcgis/rest/services/apps/hsds_dev_hub_main_table/MapServer/5`,
        formatTimeSlot: (v) => v,
    },
    {
        id: 'spend',
        label: 'Spend Index',
        gridShape: 'sqaure',
        gridIdField: 'ldn_ref',
        gridService: `https://gis.london.gov.uk/arcgis/rest/services/apps/Busyness_context/MapServer/12`,
        popupDescription:
            "Mastercard's Retail Location Index (MRLI) measuring relative credit and debit card spend.",
        dataProp: 'txn_amt',
        emptyCellProps: {
            txn_amt: 0,
        },
        dataScale: {
            dayAndNight: [
                newDataScaleItem(0, '#ffffff'),
                newDataScaleItem(50, '#e2eef8'),
                newDataScaleItem(100, '#93b2dc'),
                newDataScaleItem(150, '#4b79ae'),
                newDataScaleItem(600, '#18446c'),
            ],
        },
        dataService: `https://gis.london.gov.uk/arcgis/rest/services/apps/hsds_dev_hub_main_table/MapServer/6`,
        formatTimeSlot: (v) => (v.match(/0\d-/) ? v.slice(1) : v),
    },
];

export const visitorAndSpendTypeAtom = atom({
    key: 'visitor-and-spend-type-atom',
    default: findDefault(VISITOR_AND_SPEND_TYPES),
});

// *********************
// *** GRID FEATURES ***

export const visitorAndSpendGridCacheAtom = atom({
    key: 'visitor-and-spend-grid-cache-atom',
    default: null,
    /*
    {
      key: {
        highstreet: "",
        gridType: "",
      },
      geojson: {},
    }
  */
});
